import { firebase } from '@firebase/app';
import '@firebase/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyAiJBgEPhSlY0VoOjZoYjNlzrF7XTJGiSM',
  authDomain: 'c2c01-531c7.firebaseapp.com',
  databaseURL: 'https://c2c01-531c7.firebaseio.com',
  projectId: 'c2c01-531c7',
  storageBucket: 'c2c01-531c7.appspot.com',
  messagingSenderId: '419559245856',
  appId: '1:419559245856:web:8673dc93c3d47d1b4b1445',
});

export const db = firebaseApp.firestore();
